export default __webpack_public_path__ + "static/team-94dc0ce741301749f21c25bb4e2468f7.png";